export default class Constants {
  static readonly MAX_NUMBER_OF_2FAS_PER_TYPE = 2;
}
